var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DomHelper } from "./domHelper";
import { getBackendData } from "./xhrbackend";
import { Util } from "./util";
import { API_URL, DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from './appCardDefault';
import { appBvProcessResult } from './desk';
import { openProfile } from "./appProfile";
export function appNestedGroupRender(username, parentNode, appGroup, userResponse, bearerToken, networkRestricted) {
    if (DEBUG)
        console.log("-->appNestedGroupRender");
    const additionalClassList = [];
    if (!networkRestricted)
        additionalClassList.push('full-width-interaction');
    let content = "";
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const { children, odAppCollapsed } = appGroup, app = __rest(appGroup, ["children", "odAppCollapsed"]);
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, networkRestricted, additionalClassList, null, (event) => {
        if (DEBUG)
            console.log("NestedGroup handle Click");
        let injectNode = cardNode.querySelector('.rudi-app-inject');
        handleClickOpen(injectNode, event, username, bearerToken, appGroup, userResponse);
    });
}
function handleClickOpen(injectNode, event, username, bearerToken, appGroup, userResponse) {
    const eventNode = event.target;
    let appNode;
    const idString = appGroup.dn;
    if (eventNode) {
        try {
            appNode = DomHelper.getFirstParentWithClass(eventNode, 'rudi-app');
        }
        catch (e) {
            appNode = event.target;
        }
        if (DEBUG)
            console.log("Nested Group click", appNode);
        if (appNode) {
            const profileNode = appNode.querySelector('.rd-profile');
            if (profileNode) {
                return;
            }
            if (appNode.classList.contains("app-open")) {
                if (DEBUG)
                    console.log("RespApp do nothing");
                event.preventDefault();
            }
            else {
                event.preventDefault();
                appNode.classList.add('app-open');
                appNode.classList.remove('rudi-max-height');
                showGroupList(appNode, injectNode, appGroup, userResponse, username, bearerToken);
                DomHelper.scrollIntoView(appNode).finally();
            }
        }
    }
}
function showGroupList(appNode, injectNode, appGroup, userResponse, username, bearerToken) {
    const idString = appGroup.dn;
    injectNode.classList.remove('rudi-app-inject');
    injectNode.classList.remove('disabled');
    injectNode.classList.add('rudi-app-interaction');
    injectNode.setAttribute("id", `rudi-${idString}`);
    appNode.classList.add('rudi-col-span-3');
    DomHelper.appendCloseSection(appNode, (event) => {
        closeNestedGroupList(appNode, injectNode);
    });
    const listNode = DomHelper.appendNode(injectNode, 'ul', ['rudi-multi-column'], []);
    for (const applink of appGroup.children) {
        const hrefValue = applink.odAppLocation ? applink.odAppLocation : "";
        const listItem = DomHelper.appendNode(listNode, 'li', ['no-decoration'], []);
        const link = DomHelper.appendNode(listItem, 'a', [], [{ attr: 'href', value: hrefValue }]);
        const divBtn = DomHelper.appendNode(link, 'div', ['rudi-btn'], []);
        const divI = DomHelper.appendNode(divBtn, 'div', ['rudi-btn-icon-part'], []);
        DomHelper.appendNode(divI, 'i', [...applink.odAppIcon.split(" "), 'me-1'], []);
        const divText = DomHelper.appendNode(divBtn, 'div', ['rudi-btn-text-part'], []);
        DomHelper.appendNode(divText, 'span', [], [], applink.odAppTitle);
        if (applink.odAppType === "bv-link") {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                getBackendData(username, "/users/bvActivate/", "GET", "application/json", bearerToken, (result) => {
                    appBvProcessResult(hrefValue, result);
                });
            });
        }
        else if (applink.odAppType === "profil-school") {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                openProfile(listNode, injectNode, appNode, username, bearerToken, 'school', userResponse);
                console.log("school profile clicked");
            });
        }
        else if (applink.odAppType === "profil-rd") {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                openProfile(listNode, injectNode, appNode, username, bearerToken, 'rd', userResponse);
                console.log("rd profile clicked");
            });
        }
        else if (applink.odAppType === 'link') {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                window.open(applink.odAppLocation, "_blank");
            });
        }
    }
}
export function closeNestedGroupList(appNode, injectNode) {
    DomHelper.removeCloseSection(appNode);
    appNode.classList.remove('app-open');
    appNode.classList.remove('rudi-col-span-3');
    appNode.classList.add('rudi-max-height');
    injectNode.classList.add('rudi-app-inject');
    injectNode.classList.remove('rudi-app-interaction');
    injectNode.innerHTML = "";
    DomHelper.scrollIntoView(appNode);
}
export function appNestedGroupUploadRender(parentNode, app, userResponse, bearerToken) {
    if (DEBUG)
        console.log("-->appNestedGroupUploadRender");
    const additionalClassList = ['full-width-interaction'];
    if (userResponse.pupil) {
        getBackendData("", "/school/", "GET", "application/json", bearerToken, appNestedGroupUploadPartRender);
    }
    else {
        console.log("no profile render");
        return;
    }
    let content = "";
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList);
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-timetable-upload');
        injectNode.innerHTML = content;
    }
    else {
        console.log("Couldn't get Element to add Profile content");
    }
    DomHelper.appendSpinner(injectNode);
}
function appendTimeElement(parent, timeItem) {
    const trNode = DomHelper.appendNode(parent, 'tr', []);
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-von'], [], Util.timeStamp2TimeString(timeItem.von));
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-bis'], [], Util.timeStamp2TimeString(timeItem.bis));
    DomHelper.appendNode(trNode, 'td', ['rudi-tt-subject'], [], timeItem.subject);
    DomHelper.appendNode(trNode, 'td', ['rudi-tt-teacher'], [], timeItem.teacher);
}
function appendTimeTableHeader(parent) {
    const trNode = DomHelper.appendNode(parent, 'thead', ['thead-dark']);
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-von'], [], "von");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-bis'], [], "bis");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-subject'], [], "Fach/Thema");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-teacher'], [], "Lehrer_in");
}
function appNestedGroupPartRender(response) {
    if (DEBUG)
        console.log("-->appNestedGroupPartRender");
    const ttNode = document.getElementById("rudi-timetable");
    if (ttNode) {
        ttNode.classList.remove("disabled");
        let listNode = DomHelper.appendNode(ttNode, 'table', ['table', 'rudi-tt-list']);
        appendTimeTableHeader(listNode);
        if (response != null) {
            const timetable = JSON.parse(response.target.response);
            for (const timeItem of timetable) {
                appendTimeElement(listNode, timeItem);
            }
        }
    }
}
function appNestedGroupUploadPartRender(response) {
    if (DEBUG)
        console.log("-->appNestedGroupUploadPartRender");
    const ttNode = document.getElementById("rudi-timetable-upload");
    if (ttNode) {
        const schools = JSON.parse(response.target.response);
        ttNode.classList.remove('disabled');
        ttNode.innerHTML = "";
        const formNode = DomHelper.appendNode(ttNode, 'form', [], [
            { attr: 'id', value: 'rudi-tt-upload' },
            { attr: 'enctype', value: 'multipart/form-data' },
            { attr: 'method', value: 'POST' }
        ]);
        const uploadNode = DomHelper.appendNode(formNode, 'div', ['form-group']);
        DomHelper.appendNode(uploadNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'file' }], "Wählen Sie Stundenplan-Datei für den Upload");
        DomHelper.appendNode(uploadNode, 'input', ['form-control-file'], [
            { attr: 'type', value: 'file' },
            { attr: 'name', value: 'file' },
            { attr: 'id', value: 'file' },
        ]);
        const schoolNode = DomHelper.appendNode(formNode, 'div', ['form-group']);
        DomHelper.appendNode(schoolNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-tt-form-school' }], "Wählen Sie die Schule für den Upload");
        const selectNode = DomHelper.appendNode(schoolNode, 'select', ['form-select'], [{ attr: 'id', value: 'rudi-tt-form-school' }]);
        for (let school of schools) {
            DomHelper.appendNode(selectNode, 'option', [], [
                { attr: 'value', value: school.schoolid }
            ], school.longname);
        }
        const buttonNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-primary'], [{ attr: 'type', value: 'submit' }], 'Importieren');
        formNode.addEventListener('submit', function (event) {
            appNestedGroupUploadHandleSubmit(event);
        });
    }
}
function appNestedGroupUploadHandleSubmit(event) {
    if (DEBUG)
        console.log("-->appNestedGroupUploadHandleSubmit");
    event.preventDefault();
    let schoolid = document.getElementById('rudi-tt-form-school').value;
    let form = document.getElementById('rudi-tt-upload');
    const formData = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API_URL}/school/${schoolid}/upload`, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status !== 200) {
                console.log('Error', xhr.statusText);
            }
        }
    };
    xhr.send(formData);
}
